import { defineStore } from 'pinia';

// interfaces
import { IEnvData } from './interfaces';

export const useEnv = defineStore('env', {
    state: () => ({
        data: {
            data: {
                env: {
                    balance: 0,
                    balance_usdt: '',
                    email: '',
                    id: 0,
                    is_chat_enabled: false,
                    landing_url: '',
                    lang: '',
                    name: '',
                    profit_symbol: '',
                    status: 0,
                    timeToShutdown: null,
                    timeToStop: null,
                    timestamp: '',
                    topup_methods: [],
                    topUpBalanceDefaultAmounts: [],
                    ws_url: null,
                } as IEnvData,
                notifications: [],
            },
        },
    }),
    getters: {
        notifications(state) {
            return state.data.data.notifications;
        },
        balance(state) {
            return state.data.data.env.balance;
        },
        email(state) {
            return state.data.data.env.email;
        },
        ID(state) {
            return state.data.data.env.id;
        },
        formattedTime(state) {
            const d = new Date(state.data.data.env.timestamp);
            return d.getHours() + ':' + d.getMinutes();
        },
        formattedDate(state) {
            return new Date(state.data.data.env.timestamp).toLocaleDateString('en-US', {
                year: 'numeric', month: 'short', day: 'numeric', 
            });
        },
        timeToShutdown(state) {
            return state.data.data.env.timeToShutdown;
        },
        profitSymbol(state) {
            return state.data.data.env.profit_symbol;
        },
        topupMethods(state) {
            return state.data.data.env.topup_methods;
        },
        statusCode(state) {
            return state.data.data.env.status;
        },
        language(state) {
            return state.data.data?.env.lang;
        },
        topUpBalanceDefaultAmounts(state) {
            return state.data.data.env.topUpBalanceDefaultAmounts;
        },
    },
});